var GRID_ALIGNMENTS = ['top', 'bottom', 'center'];
var GRID_JUSTIFY = ['left', 'right', 'center'];
var GRID_GUTTER_SIZES = ['2', '4'];

export { GRID_ALIGNMENTS, GRID_GUTTER_SIZES, GRID_JUSTIFY };
